import axios from "axios";
import { toast } from "react-toastify";
import history from '@history';

let baseUrl = process.env.REACT_APP_API_KEY;

export function ForgetPassword(data) {
    let request = null;
    let url = null;
    let formData = null

    url = baseUrl + "owner/forgotpassword"
    formData = {
        email: data.email
    }
    request = axios.post(url, formData)

    return dispatch =>
        request.then(response => {
             if (response.data.message === 'User does not exist') {
                toast.error('User does not exist')
            } else {
                toast.success(response.data.message);
                history.push({
                    pathname: '/login'
                });
            }
        })
}

export function resetPassword(data) {
    let request = null;
    let url = null;
    let formData = null;

    url = baseUrl + "owner/changepassword"
    formData = {
        email: data && data.email,
        password: data && data.password
    }
    request = axios.post(url, formData)

    return dispatch =>
        request.then(response => {
            if (response.data.message === 'Link has been expired') {
                toast.error('Link has been expired')
            } else {
                toast.success(response.data.message)
                history.push({
                    pathname: '/login'
                });
            }
        })


}